import React, { useEffect, useState } from 'react';

import type { ByfunnFrapiTopTags } from '../../../types/frapi-types.js';

import { sectionMappings } from '../../layouts/front/sectionHelpers.js';
import { makeTagTitle } from '../articles/helpers.js';
import { console } from '../../../../core/system/console/index.js';

interface TopTagsProps {
  section: string;
}

export const TopTags: React.FC<TopTagsProps> = ({ section }) => {
  const [topTags, setTopTags] = useState<ByfunnFrapiTopTags>();

  useEffect(() => {
    (async () => {
      try {
        const sectionId = sectionMappings[section]?.sectionId;
        if (sectionId) {
          const res = await fetch(
            `/api/top-tags?sectionIds=${sectionMappings[section]?.sectionId}&tagTypes=machine&phrase=vink&limit=15`,
          );
          const json = await res.json();
          setTopTags(json);
        }
      } catch (e) {
        console.log(e);
      }
    })();
  }, [section]);

  return (
    <div className="top-tag-container">
      <h2 className="top-tag-title">Mye brukt:</h2>
      <div className="top-tags">
        {topTags?.items.map((t) => (
          <a
            className="regular regular-tag"
            key={t.id}
            href={`/samling/${section}/${t.id}`}
          >
            {makeTagTitle(t.title)}
          </a>
        ))}
      </div>
    </div>
  );
};
